import React from "react";
import BasePaywall from "app/components/paywalls/BasePaywall";
import segmentsIcon from "app/images/paywall-body-icon-segments.png";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

type PropsDef = {
  show?: boolean;
  onClose?: () => void;
};

export default function SegmentsPaywall({ show, onClose }: PropsDef) {
  const { t } = useTranslation();

  const upperContent = (
    <>
      <h5>{t("Lists Not Enabled")}</h5>
      <p className={styles.description}>
        {t("Upgrade to ")}{" "}
        <a href="https://coachnow.io/pricing" className={styles.highlight}>
          CoachNow PRO
        </a>
        {t(" to post or invite members to multiple Spaces and Groups at once!")}
      </p>
    </>
  );

  return (
    <BasePaywall
      show={show}
      onClose={onClose}
      title="Upgrade to Create a List"
      image={segmentsIcon}
      returnUrl="/lists"
      featureName="Lists"
      upperContent={upperContent}
    />
  );
}
